export default function generalActions() {

  /** Extra information section */
  const infoExpander = document.querySelector('.product-details-extra button');
  if (infoExpander) infoExpander.addEventListener('click', event => {
    let symbol = infoExpander.querySelector('span');
    symbol.innerHTML = symbol.innerHTML == '+' ? '&ndash;' : '+';
    infoExpander.parentElement.classList.toggle('expanded');
    event.preventDefault();
  });
}


// WEBPACK FOOTER //
// ./source/scripts/products/actions/general.js